import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-head box-shadow bg-white d-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25 gap-3" }
const _hoisted_3 = { class: "d-inline-flex flex-wrap gap-3 justify-content-end" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "ph-bold ph-plus position-relative ms-5 fs-12" }, null, -1 /* HOISTED */)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "ph-bold ph-plus position-relative ms-5 fs-12" }, null, -1 /* HOISTED */)
const _hoisted_7 = {
  key: 0,
  class: "card-select align-items-center d-inline-block d-inline-flex mt-md-0 ms-auto"
}
const _hoisted_8 = { class: "fw-medium text-muted me-8" }
const _hoisted_9 = {
  value: -1,
  class: "fw-medium"
}
const _hoisted_10 = ["value"]
const _hoisted_11 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_12 = {
  key: 1,
  class: "table-responsive"
}
const _hoisted_13 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}, " ID ", -1 /* HOISTED */)
const _hoisted_15 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_16 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_17 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_18 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_19 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_20 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
}, null, -1 /* HOISTED */)
const _hoisted_22 = { class: "linked" }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { class: "d-flex align-items-center justify-content-start" }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = ["onClick"]
const _hoisted_27 = ["onClick"]
const _hoisted_28 = ["onClick"]
const _hoisted_29 = ["onClick"]
const _hoisted_30 = ["onClick"]
const _hoisted_31 = { class: "shadow-none lh-1 fw-medium text-body-tertiary text-end" }
const _hoisted_32 = { class: "dropdown position-static" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("button", {
  class: "dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition",
  type: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false",
  "data-bs-boundary": "viewport"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-dots" })
], -1 /* HOISTED */)
const _hoisted_34 = { class: "dropdown-menu" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("i", { class: "ph ph-eye lh-1 me-8 position-relative top-1" }, null, -1 /* HOISTED */)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("i", { class: "ph-duotone ph-pencil lh-1 me-8 position-relative top-1" }, null, -1 /* HOISTED */)
const _hoisted_37 = ["onClick"]
const _hoisted_38 = {
  key: 0,
  class: "spinner-border spinner-border-xs border-1 me-8",
  role: "status",
  "aria-hidden": "true"
}
const _hoisted_39 = {
  key: 1,
  class: "ph ph-arrow-clockwise lh-1 me-8 position-relative top-1"
}
const _hoisted_40 = ["onClick"]
const _hoisted_41 = /*#__PURE__*/_createElementVNode("i", { class: "ph ph-trash lh-1 me-8 position-relative top-1" }, null, -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SpinnerLoading = _resolveComponent("SpinnerLoading")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_TablePagination = _resolveComponent("TablePagination")!
  const _component_AlertModal = _resolveComponent("AlertModal")!
  const _component_ConfirmModal = _resolveComponent("ConfirmModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.admin_roles, (role) => {
            return (_openBlock(), _createElementBlock("button", {
              key: role.id,
              onClick: ($event: any) => (_ctx.createUser(role)),
              class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block text-decoration-none"
            }, [
              _createTextVNode(_toDisplayString(_ctx.$t('cta.create')) + " " + _toDisplayString(role.name) + " ", 1 /* TEXT */),
              _hoisted_5
            ], 8 /* PROPS */, _hoisted_4))
          }), 128 /* KEYED_FRAGMENT */)),
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/create-user'))),
            class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block text-decoration-none"
          }, [
            _createTextVNode(_toDisplayString(_ctx.$t('cta.create_user')) + " ", 1 /* TEXT */),
            _hoisted_6
          ]),
          _createCommentVNode(" <router-link to=\"/create-user\"\n          class=\"default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block text-decoration-none\">\n          {{ $t('cta.create_user') }}\n          <i class=\"ph-bold ph-plus position-relative ms-5 fs-12\"></i>\n        </router-link> ")
        ]),
        _createCommentVNode(" ROLE FILTER "),
        (_ctx.admin_roles.length > 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t('form.role.label')), 1 /* TEXT */),
              _withDirectives(_createElementVNode("select", {
                class: "form-select shadow-none text-black border-0 p-15 pe-50 bg-body-tertiary fs-14 fw-medium",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.roleId) = $event)),
                onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.setFilter && _ctx.setFilter(...args)))
              }, [
                _createElementVNode("option", _hoisted_9, _toDisplayString(_ctx.$t('cta.show_all')), 1 /* TEXT */),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.admin_roles, (role) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: role.id,
                    value: role.id,
                    class: "fw-medium"
                  }, _toDisplayString(role.name), 9 /* TEXT, PROPS */, _hoisted_10))
                }), 128 /* KEYED_FRAGMENT */))
              ], 544 /* NEED_HYDRATION, NEED_PATCH */), [
                [_vModelSelect, _ctx.roleId]
              ])
            ]))
          : _createCommentVNode("v-if", true)
      ]),
      _createElementVNode("div", _hoisted_11, [
        (_ctx.users === undefined)
          ? (_openBlock(), _createBlock(_component_SpinnerLoading, {
              key: 0,
              class: "mt-50"
            }))
          : (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createElementVNode("table", _hoisted_13, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _hoisted_14,
                    _createElementVNode("th", _hoisted_15, _toDisplayString(_ctx.$t('form.first_name.label')), 1 /* TEXT */),
                    _createElementVNode("th", _hoisted_16, _toDisplayString(_ctx.$t('form.last_name.label')), 1 /* TEXT */),
                    _createElementVNode("th", _hoisted_17, _toDisplayString(_ctx.$t('form.role.label')), 1 /* TEXT */),
                    _createElementVNode("th", _hoisted_18, _toDisplayString(_ctx.$t('form.role_in_department.label')), 1 /* TEXT */),
                    _createElementVNode("th", _hoisted_19, _toDisplayString(_ctx.$t('form.email.label')), 1 /* TEXT */),
                    _createElementVNode("th", _hoisted_20, _toDisplayString(_ctx.$t('form.phone.label')), 1 /* TEXT */),
                    _hoisted_21
                  ])
                ]),
                _createElementVNode("tbody", _hoisted_22, [
                  _createCommentVNode(" PATIENT ROW "),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.users, (user) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: user.id
                    }, [
                      _createElementVNode("th", {
                        class: "shadow-none lh-1 fw-medium text-body-tertiary title",
                        onClick: ($event: any) => (_ctx.show(user))
                      }, [
                        _createElementVNode("div", _hoisted_24, _toDisplayString(user.id), 1 /* TEXT */)
                      ], 8 /* PROPS */, _hoisted_23),
                      _createElementVNode("td", {
                        class: "shadow-none lh-1 fw-medium text-body-tertiary",
                        onClick: ($event: any) => (_ctx.show(user))
                      }, _toDisplayString(user.firstname), 9 /* TEXT, PROPS */, _hoisted_25),
                      _createElementVNode("td", {
                        class: "shadow-none lh-1 fw-medium text-body-tertiary",
                        onClick: ($event: any) => (_ctx.show(user))
                      }, _toDisplayString(user.lastname), 9 /* TEXT, PROPS */, _hoisted_26),
                      _createElementVNode("td", {
                        class: "shadow-none lh-1 fw-medium text-black-emphasis",
                        onClick: ($event: any) => (_ctx.show(user))
                      }, _toDisplayString(user.role.name), 9 /* TEXT, PROPS */, _hoisted_27),
                      _createElementVNode("td", {
                        class: "shadow-none lh-1 fw-medium text-body-tertiary",
                        onClick: ($event: any) => (_ctx.show(user))
                      }, _toDisplayString(user.role_in_department), 9 /* TEXT, PROPS */, _hoisted_28),
                      _createElementVNode("td", {
                        class: "shadow-none lh-1 fw-medium text-primary",
                        onClick: ($event: any) => (_ctx.show(user))
                      }, _toDisplayString(user.email), 9 /* TEXT, PROPS */, _hoisted_29),
                      _createElementVNode("td", {
                        class: "shadow-none lh-1 fw-medium text-body-tertiary",
                        onClick: ($event: any) => (_ctx.show(user))
                      }, _toDisplayString(user.phone_number), 9 /* TEXT, PROPS */, _hoisted_30),
                      _createElementVNode("td", _hoisted_31, [
                        _createElementVNode("div", _hoisted_32, [
                          _hoisted_33,
                          _createElementVNode("ul", _hoisted_34, [
                            _createElementVNode("li", null, [
                              _createVNode(_component_router_link, {
                                to: { path: `/user/${user.id}` },
                                class: "dropdown-item d-flex align-items-center"
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_35,
                                  _createTextVNode(" " + _toDisplayString(_ctx.$t('cta.view')), 1 /* TEXT */)
                                ]),
                                _: 2 /* DYNAMIC */
                              }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"])
                            ]),
                            _createElementVNode("li", null, [
                              _createVNode(_component_router_link, {
                                to: { path: `/user/${user.id}/edit` },
                                class: "dropdown-item d-flex align-items-center"
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_36,
                                  _createTextVNode(" " + _toDisplayString(_ctx.$t('cta.edit')), 1 /* TEXT */)
                                ]),
                                _: 2 /* DYNAMIC */
                              }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"])
                            ]),
                            _createElementVNode("li", null, [
                              _createElementVNode("button", {
                                class: "dropdown-item d-flex align-items-center",
                                onClick: (e) => _ctx.recoveryPassword(user, e)
                              }, [
                                (_ctx.recovery_loading)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_38))
                                  : (_openBlock(), _createElementBlock("i", _hoisted_39)),
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('cta.recovery_password')), 1 /* TEXT */)
                              ], 8 /* PROPS */, _hoisted_37)
                            ]),
                            _createElementVNode("li", null, [
                              _createElementVNode("button", {
                                class: "dropdown-item d-flex align-items-center",
                                onClick: ($event: any) => (_ctx.confirmDeleteUser(user))
                              }, [
                                _hoisted_41,
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('cta.delete')), 1 /* TEXT */)
                              ], 8 /* PROPS */, _hoisted_40)
                            ])
                          ])
                        ])
                      ])
                    ]))
                  }), 128 /* KEYED_FRAGMENT */))
                ])
              ])
            ])),
        _createCommentVNode(" PAGINATION "),
        _createVNode(_component_TablePagination, {
          count: _ctx.users?.length ?? 0,
          page: _ctx.currentPage,
          total: _ctx.totalUsers,
          pages: _ctx.lastPage,
          onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setPage($event)))
        }, null, 8 /* PROPS */, ["count", "page", "total", "pages"])
      ])
    ]),
    _createVNode(_component_AlertModal, {
      id: "recovery_modal",
      title: _ctx.$t('feature.auth.$recovery_user_password.title'),
      message: _ctx.recovery_modal_message
    }, null, 8 /* PROPS */, ["title", "message"]),
    _createVNode(_component_ConfirmModal, {
      onConfirm: _cache[4] || (_cache[4] = ($event: any) => (_ctx.deleteUser())),
      title: _ctx.$t('cta.$delete.title'),
      message: _ctx.$t('cta.$delete.message')
    }, null, 8 /* PROPS */, ["title", "message"])
  ], 64 /* STABLE_FRAGMENT */))
}